module.exports = __webpack_public_path__ + "static/media/usersLegendIcon.b195ce95.svg";